if (!customElements.get("scroll-shadow")) {
  class ScrollShadow extends HTMLElement {
    constructor() {
      super();
      this.scrollContainer = null;
      this.handleScrollBound = this.handleScroll.bind(this);
    }

    connectedCallback() {
      const targetSelector = this.getAttribute("target");
      if (!targetSelector) {
        console.warn("scroll-shadow: target attribute is required");
        return;
      }

      // Find the scroll container - either within this element or globally
      this.scrollContainer = this.querySelector(targetSelector) || document.querySelector(targetSelector);

      if (!this.scrollContainer) {
        console.warn("scroll-shadow: target element not found:", targetSelector);
        return;
      }

      // Set initial state
      this.handleScroll();

      // Listen to scroll events
      this.scrollContainer.addEventListener("scroll", this.handleScrollBound, { passive: true });
    }

    disconnectedCallback() {
      if (this.scrollContainer) {
        this.scrollContainer.removeEventListener("scroll", this.handleScrollBound);
      }
    }

    handleScroll() {
      if (!this.scrollContainer) return;

      const scrollLeft = this.scrollContainer.scrollLeft;
      const scrollWidth = this.scrollContainer.scrollWidth;
      const clientWidth = this.scrollContainer.clientWidth;

      // Check if scrolled all the way to the left
      if (scrollLeft <= 1) {
        this.classList.add("scrolled-to-left");
        this.classList.remove("scrolling", "scrolled-to-right");
      }
      // Check if scrolled all the way to the right
      else if (scrollLeft + clientWidth >= scrollWidth - 1) {
        this.classList.add("scrolled-to-right");
        this.classList.remove("scrolling", "scrolled-to-left");
      }
      // In the middle
      else {
        this.classList.add("scrolling");
        this.classList.remove("scrolled-to-left", "scrolled-to-right");
      }
    }
  }

  customElements.define("scroll-shadow", ScrollShadow);
}
